import { ORGANIZATION_ASSISTANT_DESTINATIONS } from "@simplyk/common";
import type { ToolUIPart } from "ai";

import { readCampaignType } from "./readCampaignType";

import { isOutcomeUncertain, type ToolPartDisplay } from "@/features/Assistant/Thread/ToolPart/helpers";

export const DESTINATIONS: ReadonlySet<string> = new Set(ORGANIZATION_ASSISTANT_DESTINATIONS);

export const getOrganizationToolPartDisplay = (part: ToolUIPart): ToolPartDisplay => {
  if (part.state === "input-streaming" || part.state === "input-available") {
    return "pending";
  }
  if (part.type === "tool-requestFeedback") {
    return "hidden";
  }
  if (part.state === "approval-requested" || part.state === "approval-responded" || part.state === "output-denied") {
    return "content";
  }
  if (isOutcomeUncertain(part)) {
    return "content";
  }
  if (part.type === "tool-openDashboardPage" && part.state === "output-available" && isOpenedPage(part.output)) {
    return "content";
  }
  if (
    part.type === "tool-recommendCampaignType" &&
    part.state === "output-available" &&
    readCampaignType(part.output)
  ) {
    return "content";
  }
  return "hidden";
};

const isOpenedPage = (output: unknown): boolean =>
  typeof output === "object" &&
  output !== null &&
  !("error" in output) &&
  "destination" in output &&
  typeof output.destination === "string" &&
  DESTINATIONS.has(output.destination);
